const DEFAULT_ACCESS = {
  can_submit_referrals: true,
  status: 'active',
};

export function getReferralAccessFromMembership(membership) {
  return membership?.referral_access ?? DEFAULT_ACCESS;
}

export function canSubmitReferrals(referralAccess) {
  return referralAccess?.can_submit_referrals !== false;
}

export function getReferralAccessMessage(referralAccess, t) {
  if (!referralAccess || canSubmitReferrals(referralAccess)) {
    return null;
  }

  if (referralAccess.reason) {
    return referralAccess.reason;
  }

  if (referralAccess.status === 'suspended') {
    return t('referralAccess.suspendedDefault');
  }

  return t('referralAccess.blockedDefault');
}

export function formatSuspendedUntil(referralAccess) {
  if (!referralAccess?.suspended_until) {
    return null;
  }

  const date = new Date(referralAccess.suspended_until);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function getReferralAccessTooltip(referralAccess, t) {
  const message = getReferralAccessMessage(referralAccess, t);
  if (!message) {
    return null;
  }

  const until = formatSuspendedUntil(referralAccess);
  if (referralAccess?.status === 'suspended' && until) {
    return `${message} ${t('referralAccess.suspendedUntil', { date: until })}`;
  }

  return message;
}
